/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {cashFrontendServiceGetTrustpilotUrlPayload} from '../api'

export const useMutationCashFrontendServiceGetTrustpilotUrlPayload = createReactQueryMutationHook('cashFrontendServiceGetTrustpilotUrlPayload', cashFrontendServiceGetTrustpilotUrlPayload)
